import { Suspense, useEffect, useState } from 'react';

import { fetchStudentsTestingResults } from '../../http/User_API';
import { ClenseNumeral } from '../../utils/PageDataPrepare';

import './AccountPageTestingBlock.css';

//  Содержимое каждого блока с информацией о студенте и его результатах прохождения тестирования.
const StudentTestResultsBlock = ({ t, lang, data }) => {
    const [ expanded, setExpanded ] = useState(false);

    const handleToggleExpanded = () => {
        setExpanded( p => !p );
    }

    if (!data || !data?.profile)
        return;

    return <div className='testing-results_user-block'>
        <div className={ 'user-block_name' + (expanded ? ' expanded' : '' ) } onClick={handleToggleExpanded}>
            <div>{data.profile.lastName} {data.profile.firstName}</div>
            <div className='user-block_faded-text'>{data.profile.faculty}</div>
        </div>
        {expanded && <div className='user-block_results'>
            {data.tests.length === 0 && <p className='no-data'>{t('profile_student_quiz_results_didnt_complete')}</p>}
            {data.tests.map( test => <div key={test.id} className='user-block_testing-block'>
                <div className='testing-block_icon'>
                    <img src={test.icon} alt='Иконка для категории' />
                </div>
                <div className='testing-block_title'>
                    {test.name[lang]}
                </div>
                <div className='testing-block_grade'>
                    {test.correct}&nbsp;/&nbsp;{test.questions.length}&nbsp;{t('profile_student_quiz_results_correct')}&nbsp;
                    ({Math.round(test.correctPercent)}%)
                </div>
                <div className='testing-block_date'>
                    {new Date(test.createdAt).toLocaleString()}
                </div>
            </div>)}
        </div>}
    </div>;
};

//  Блок со списком студентов, которые проходили тестирование.
const StudentTestResults = ({ t, user, filter, setError }) => {
    const [ students, setStudents ] = useState([]);

    useEffect( () => {
        fetchStudentsTestingResults().then( r => r?.error ? setError(r.error) : setStudents(r) );
    }, []);

    const handleListFilter = (value) => {
        if (filter.search == null && !filter.onlyGraded)
            return true;

        if (filter.search)
        {
            const matchingNameSurname = (value.profile.firstName + ' ' + value.profile.lastName).toLocaleLowerCase().includes(filter.search.toLocaleLowerCase());
            
            if (filter.onlyGraded)
                return value.tests.length > 0 && matchingNameSurname;
            else
                return matchingNameSurname;
        }
        else
        {
            return filter.onlyGraded ? value.tests.length > 0 : true;
        }
    };

    return <>
        {(filter.search || filter.onlyGraded) ? <>
            <strong>
                {t('profile_student_quiz_results_students_total', { returnObjects: true })[0]}:&nbsp;
            </strong>
            {students.filter(handleListFilter).length}&nbsp;
            {ClenseNumeral(students.filter(handleListFilter).length, [ t('plural_student_1'), t('plural_student_2'), t('plural_student_5') ])}
        </> : <>
            <strong>
                {t('profile_student_quiz_results_students_total', { returnObjects: true })[0]}:&nbsp;
            </strong>
            {students.length}&nbsp;
            {ClenseNumeral(students.length, [ t('plural_student_1'), t('plural_student_2'), t('plural_student_5') ])}&nbsp;
            {t('profile_student_quiz_results_students_total', { returnObjects: true })[1]}&nbsp;
            &laquo;{user?.profile.profile.university}&raquo;
        </>}

        <div className='testing-results_users'>
            {students?.filter(handleListFilter)?.map( u => <StudentTestResultsBlock key={u.id} t={t} lang={user?.language} data={u} /> )}
        </div>
    </>;
};

//  Блок на странице профиля с информацией обо всех тестах, которые были пройдены пользователями, входящими в состав университета этого пользователя.
const ControlledUsersPassedQuizzesBlock = ({ t, user, error, setError }) => {
    const [ filter, setFilter ] = useState({ search: null, onlyGraded: false });

    //  Изменение какого-либо фильтра.
    const handleFiltersChange = (event) => {
        setFilter( p => ({
            ...p,
            [event.target.name]: event.target.type === 'select-one' ? event.target.value === 'true' : event.target.value
        }) );
    };

    return <div className='testing_results'>
        <div className='group'>
            <div className='heading'>{t('profile_student_quiz_results_title')} {user.profile.profile.moodle?.clientdescription}</div>
            <div>{t('profile_student_quiz_results_hint')}</div>
        </div>
        <br />
        <form className='form-floating row' onSubmit={ e => e.preventDefault() } onChange={handleFiltersChange}>
            <div className='col'>
                <label>{t('profile_student_quiz_results_filter_search')}</label>
                <input type='text' className='form-control' name='search' defaultValue={filter.search} />
            </div>
            <div className='col'>
                <label>{t('profile_student_quiz_results_filter_display')}</label>
                <select className='form-control' name='onlyGraded' defaultValue={filter.onlyGraded}>
                    <option value={false}>{t('profile_student_quiz_results_filter_display_all')}</option>
                    <option value={true}>{t('profile_student_quiz_results_filter_display_completed')}</option>
                </select>
            </div>
        </form>

        <hr />

        <Suspense fallback={<p>Загрузка</p>}>
            <StudentTestResults t={t} user={user} filter={filter} setError={setError} />
        </Suspense>
    </div>;
};

export default ControlledUsersPassedQuizzesBlock;